var $ = require("./lib/qsa");
var colors = require("./lib/colors");

var container = $.one(".floater.demo");

if (container) {

  var canvas = $.one("canvas", container);
  var context = canvas.getContext("2d");
  var svg = $.one("svg", container);
  var warningLight = $.one(".warning.a", container);

  var working = $.one("#ball", container);
  var broken = $.one("#ballBent", container);
  var workingBounds = $.one(".st5", working).getBBox();
  workingBounds.midY = workingBounds.y + workingBounds.height * .5;
  var brokenBounds = $.one(".st5", broken).getBBox();
  brokenBounds.midY = brokenBounds.y + brokenBounds.height * .5;

  var svgBox = svg.getAttribute("viewBox").toString().split(" ").map(Number);

  var genesis = Date.now();
  var levelAmp = .1;
  var levelHeight = .26;
  var levelPeriod = 3000;
  var wavePeriod = 300;
  var waveHeight = .01;
  var waveFreq = .567;
  var floaterSize = .05;
  var dangerZone = .7;

  var depthAtT = function(dt) {
    var variance = Math.sin(dt / levelPeriod - Math.PI * .5) * levelAmp;
    var level = levelHeight + variance;
    var depth = canvas.height - level * canvas.height;
    return depth;
  }

  var waveAtX = function(x, dt = 0) {
    //wave is influenced by the distance across the top and time
    var period = dt / wavePeriod;
    return Math.cos(dt / wavePeriod + x * Math.PI / waveFreq) * waveHeight;
  };

  var render = function(dt = 0) {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    //generate the top of the water
    var depth = depthAtT(dt);
    context.beginPath();
    for (var x = 0; x <= 1.1; x += .05) {
      var y = depth + (canvas.height * waveAtX(x, dt));
      context[!x ? "moveTo" : "lineTo"](x * canvas.width, y);
    }
    context.lineTo(canvas.width, canvas.height);
    context.lineTo(0, canvas.height);
    context.fillStyle = "#575352";
    context.fill();

    // move the floaters
    var svgBounds = svg.getBoundingClientRect();
    var workingFloaterY = depth + (canvas.height * waveAtX(.3, dt));
    // working.style.transform = `translateY(${workingFloaterY - workingBounds.midY}px)`;
    var workingY = workingFloaterY - (workingBounds.midY * svgBounds.height / svgBox[3]);
    working.setAttribute("transform", `translate(0 ${workingY})`);

    var brokenFloaterY = depth + (canvas.height * waveAtX(.7, dt));
    var bend = .76;
    if (brokenFloaterY < canvas.height * bend) {
      brokenFloaterY = canvas.height * bend;
      container.classList.add("stuck");
    } else {
      container.classList.remove("stuck");
    }
    // broken.style.transform = `translateY(${brokenFloaterY - brokenBounds.midY}px)`;
    var brokenY = brokenFloaterY - (brokenBounds.midY * svgBounds.height / svgBox[3]);
    broken.setAttribute("transform", `translate(0 ${brokenY})`);

    //draw the danger zone
    var dash = 10;
    context.strokeStyle = colors.palette.stDarkRed;
    for (var x = 0; x < canvas.width; x += dash * 2) {
      context.beginPath();
      context.moveTo(x, canvas.height * dangerZone);
      context.lineTo(x + dash, canvas.height * dangerZone);
      context.stroke();
    }
    //trigger the alarm on high alert
    if (workingFloaterY < canvas.height * dangerZone) {
      container.classList.add("danger");
    } else {
      container.classList.remove("danger");
    }
  };

  var frame = function() {
    var now = Date.now();
    var elapsed = now - genesis;
    render(elapsed);
    requestAnimationFrame(frame);
  };

  frame();

}